import { render, staticRenderFns } from "./big-snackbar.vue?vue&type=template&id=a8fcef80&"
import script from "./big-snackbar.vue?vue&type=script&lang=js&"
export * from "./big-snackbar.vue?vue&type=script&lang=js&"
import style0 from "./big-snackbar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VScaleTransition,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8fcef80')) {
      api.createRecord('a8fcef80', component.options)
    } else {
      api.reload('a8fcef80', component.options)
    }
    module.hot.accept("./big-snackbar.vue?vue&type=template&id=a8fcef80&", function () {
      api.rerender('a8fcef80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/big-snackbar.vue"
export default component.exports